import { useEffect } from "react";

const BASE_URL = "https://soletosole.com";

/**
 * Sets the canonical link tag dynamically per page.
 * @param path - The path for this page (e.g., "/events", "/apply"). Defaults to "/".
 */
export const useCanonical = (path: string = "/") => {
  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    
    if (link) {
      link.href = url;
    } else {
      link = document.createElement("link");
      link.rel = "canonical";
      link.href = url;
      document.head.appendChild(link);
    }

    return () => {
      // Reset to base URL on unmount so there's always a canonical
      if (link) {
        link.href = BASE_URL + "/";
      }
    };
  }, [path]);
};
